import { action, makeObservable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import type { RoleGroups } from "../../api";
import type { RepositoryUsers } from "../../domain/repositories/repository-users";
import { type UUID } from "../../utils/uuid";
import { ListCommandButtons, type ListCommandButtonsProps } from "./list-command-buttons";
import { FormCreateUser } from "../molecules/form-create-user";
import { FormUpdateUser } from "../molecules/form-update-user";
import { defaultPageSize } from "../../utils/constants";

export type ListCommandButtonsUsersProps = Omit<
    ListCommandButtonsProps<RepositoryUsers>,
    "list" | "createForm" | "on" | "listState"
> & {
    readonly roleGroup?: RoleGroups;
};

import { store } from "../../store";

@observer
export class ListCommandButtonsUsers extends React.Component<ListCommandButtonsUsersProps> {
    constructor(props: ListCommandButtonsUsersProps) {
        super(props);
        makeObservable(this);
    }

    @action.bound private async deleteUsers(ids: UUID[]): Promise<void> {
        await store.repositoryUsers.delete(...ids);
        if (this.props.onDelete) {
            this.props.onDelete(ids);
        }
    }

    @action.bound private reloadUsers(): void {
        store.repositoryUsers.reloadQuery({
            pageSize: defaultPageSize,
            roleGroup: this.props.roleGroup,
        });
    }

    public render(): JSX.Element {
        return (
            <ListCommandButtons
                updateForm={FormUpdateUser}
                createForm={FormCreateUser}
                listState={store.serviceListStates.users}
                createButtonText={store.i18n.t("listUsers.button.add")}
                createDialogTitle={store.i18n.t("listUsers.createDialog.title")}
                updateDialogTitle={store.i18n.t("listUsers.updateDialog.title")}
                {...this.props}
                onDelete={this.deleteUsers}
                onUpdate={this.reloadUsers}
                onCreate={this.reloadUsers}
                dialogMaxWidth="800px"
            />
        );
    }
}
